import {isFunction} from 'lodash';
import React, {FC, PropsWithChildren} from 'react';
import {useDragLayer} from 'react-dnd';
import styled from 'styled-components';

import {Layer} from '../../../../../libs/shared/ui/src/components/layers/layer';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';
import {boxShadow} from '../../../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {SwitcherDragItemType} from './draggableSwitcherItem';

/*
 * Style.
 */

const StyledDraggingDiv = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  z-index: 10;

  overflow: hidden;
  border-radius: 15px;
  ${center()};

  background-color: ${(p) => p.theme.foreground};
  ${(p) => boxShadow(p.theme, `0 7px 20px ${p.theme.alphas.black50}`)};
`;

/*
 * Component.
 */

export const DragLayerSwitcherItem: FC<PropsWithChildren<unknown>> = () => {
  // If our target is not currently being dragged, nothing to do.
  const {item, offset, itemType} = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    offset: monitor.getSourceClientOffset(),
    itemType: monitor.getItemType(),
  }));

  if (!offset || !item || itemType !== SwitcherDragItemType || !isFunction(item.children)) {
    return null;
  }

  // Otherwise, render the drag layer.
  return (
    <Layer isInteractive={false}>
      <StyledDraggingDiv style={{transform: `translate(${offset.x}px, ${offset.y}px)`}}>
        {item.children(true)}
      </StyledDraggingDiv>
    </Layer>
  );
};
